import React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import { SFDefaultUserProfile64 } from "../icons/base64Svgs";

const getInitials = (name) => {
  let initials = name.split(" ");
  return (initials[0][0] + initials[initials.length - 1][0]).toUpperCase();
};

const getSrc = (src) => {
  return src.includes("data:image/png;base64")
    ? src
    : `data:image/png;base64, ${src}`;
};

const SFAvatar = ({ name, src, defaultSrc, className, icon }) => {
  if (icon) {
    return (
      <Avatar {...(className && { className: className })} alt={name}>
        {icon}
      </Avatar>
    );
  } else if (src?.length > 0) {
    return (
      <Avatar
        {...(className && { className: className })}
        alt={name}
        src={getSrc(src)}
      />
    );
  } else if (name?.length > 0) {
    return (
      <Avatar {...(className && { className: className })} alt={name}>
        {getInitials(name)}
      </Avatar>
    );
  } else {
    return (
      <Avatar
        {...(className && { className: className })}
        src={
          defaultSrc
            ? getSrc(defaultSrc)
            : `data:image/png;base64, ${SFDefaultUserProfile64}`
        }
      />
    );
  }
};

SFAvatar.propTypes = {
  src: PropTypes.string,
  defaultSrc: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.element, // Update the icon prop type to element
};

export default SFAvatar;
